import PropTypes from 'prop-types'
import React from 'react'

import { useWebinarDesignQuery } from '../../../Designs/blocs/useWebinarDesign'
import { useBrandGraphic } from '../../../Designs/blocs/brandResolvers'

import './WebinarRoomHeaderComponent.scss'

const WebinarRoomHeaderComponent = ({ children }) => {
  const { data: webinarDesign } = useWebinarDesignQuery()
  const resolveBrandGraphic = useBrandGraphic()

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const logo = webinarDesign?.designData['room-settings']?.graphics?.logo

  const brandedLogo = resolveBrandGraphic(logo)

  return (
    <div className="webinar-room-header-component">
      {logo && (
        <img
          className="site-logo"
          src={brandedLogo}
          alt=""
          onError={(event) => {
            // eslint-disable-next-line no-param-reassign
            event.currentTarget.style.display = 'none'
          }}
        />
      )}
      {children}
    </div>
  )
}

WebinarRoomHeaderComponent.propTypes = {
  children: PropTypes.node,
}

export default WebinarRoomHeaderComponent
